export default {
  news: {
    fetching: false,
    fetched: false,
    submitting: false,
    submitted: false,
    data: null
  }
}
